<template>
    <el-row :gutter="20" style="padding: 30px;min-height: 800px;">
        <el-card shadow="nerver" class="devTable">
            <span v-for="item in tableList" :key="item" :class="getTableItemColor(item)"
                @click="clickTableItem(item)">{{ item }}</span>
        </el-card>
        <div class="el-line-h"></div>

        <div class="titleBar">
            <div class="titletitle" style="width: 500px;">商品信息</div>
            <div class="titletitle"  style="width: 180px;">价格</div>
            <div class="titletitle"  style="width: 180px;">状态</div>
        </div>
        <el-card shadow="never" v-for="order in orderlist" :key="order.orderID" class="subgamecard" @click.native="">
            <img :src="order.FirstImage" class="gameimg">
            <div class="sub2">
                <span class="gamedetail">{{ order.Details }}</span>
            </div>
            <div class="sub3">
                <span class="gameprice2"> ¥</span>
                <span class="gameprice1">{{ order.Price }}</span>
            </div>
            <div class="sub4">
                <el-button plain class="sub4btn" @click="onGoodsdetails(goods)">已完成</el-button>
            </div>
        </el-card>


    </el-row>

</template>

<script>

import netutil from "../../common/netutil.js";
import accounts from '../../common/accounts.js';
export default {
    name: "",
    data() {
        return {
            activeItem: "全部订单",
            orderlist: [
               
            ],
            tableList: ["全部订单", "待付款", "待发货", "已成交", "已取消", "退款"]

        };
    },
    components: {

    },
    computed: {
        username() {
            return accounts.Accounts();
        },
        head() {
            return accounts.HeadImg();
        },
        userinfo() {
            return accounts.Info();
        },


    },
    created() {
        this.orderlist=[];
    },
    activated() {

    },
    deactivated() {

    },
    methods: {
        getTableItemColor(a) {
            return (a == this.activeItem) ? "tableItem tableItemActive" : "tableItem";
        },
        clickTableItem(A) {
            for (let i = 0; i < this.tableList.length; ++i) {
                if (A == this.tableList[i]) this.activeItem = this.tableList[i];
            }

            if ("全部" == A) {


            }
            else {

            }

        },


    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.devTable {
    background-color: #f1f1f1;
    border-radius: 30px;
    height: 60px;
}

.tableItem {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    color: #717171;
    font-size: 20px;
    cursor: pointer;
}

.tableItem:hover {
    color: #000000;
}

.tableItemActive {
    color: #000000;
    font-size: 22px;
}



.subgamecard {
    cursor: pointer;
    border-color: #ffffff;
    border-bottom: 0.5px solid #dadada;
}

.gameimg {
    width: 280px;
    height: 150px;
    float: left;
    border-radius: 10px;
}

.sub2 {
    width: 450px;
    float: left;
    padding: 10px;
    height: 100%;
}

.sub3 {
    width: 200px;
    float: left;
    padding: 10px;
    height: 100%;
}

.sub4 {
    width: 100px;
    padding: 10px;
    float: right;
    height: 140px;
}

.sub4btn {
    margin-top: 50px;
}

.gamedetail {
    font-size: 16px;
    color: #717171;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
}

.gameprice1 {
    font-size: 32px;
    color: #ff3c00;
    line-height: 140px;
}

.gameprice2 {
    font-size: 22px;
    color: #ff3c00;
    padding-top: 20px;
    padding-right: 5px;
    margin-left: 30px;
    line-height: 140px;
}

.titleBar{
    background-color: #f1f1f1;
    height: 48px;
    margin-top: 20px;
}

.titletitle
{
    float: left;
    height: 48px;
    line-height: 48px;
    text-align: center;
}
</style>
